<template>
  <div class="main" v-loading="loading">
    <div class="base-form">
      <el-form
        ref="form"
        :model="baseformData"
        label-width="100px"
        style="overflow: hidden;padding-top:5px;padding-right:5px;"
        :show-message="false"
      >
        <el-col :span="12">
          <el-form-item label="题目类型" required>
            <el-select
              :style="{width: '100%'}"
              v-model="formData.templateId"
              placeholder="请选择题目类型"
              @change="changeSelect"
              :disabled="$route.query.id?true:false"
            >
              <el-option v-for="(item,i) in questionType" :key="i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="题目难度" prop="level" required>
            <el-select
              :style="{width: '100%'}"
              v-model="baseformData.level"
              placeholder="请选择题目难度"
            >
              <el-option v-for="(item,i) in questionLevel" :key="i" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课程目录" prop="directoryId">
            <el-cascader ref="cascader" style="width:100%" :popper-append-to-body="false" popper-class="custom-dropdown"
              v-model="baseformData.directoryId"
              :show-all-levels="false" clearable filterable
              :props="props" :options="directoryList"
              @change="handleChange"
              ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键字" :show-message="!baseformData.questionKey">
            <label-input @on-change="changeKey" :parentarr="getKey" ref="labelInput" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="适合专业">
            <el-checkbox-group v-model="baseformData.profession" @change="updateProfessionName">
              <el-checkbox :label="val.id" v-for="val in professionData" :key="val.id">{{val.dictionaryName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <el-form
      ref="formV2"
      :rule="rules"
      :model="formData"
      label-width="110px"
      @submit.native.prevent
      class="main-form"
      :show-message="false"
      >
      <tp-textarea :data="formData.textareaData"></tp-textarea>
      <upload-img :data="formData.UIdata" :key="formData.UIdata.fieldId"></upload-img>
      <input-upload-img :data="formData.answer" ref="IUIFORM"></input-upload-img>
      <tp-textarea :data="formData.jxtextareaData"></tp-textarea>
      <upload-img :data="formData.jxUIdata" :key="formData.jxUIdata.fieldId"></upload-img>
    </el-form>
    <div class="btns">
      <div style="display:inline-block">
        <el-button type="primary" plain @click="close(true)">取消</el-button>
        <el-button
          type="primary"
          style="width:120px;margin-left: 10px"
          @click="submit(false)"
        >保存</el-button>
        <el-button v-if="!$route.query.id"
          type="primary"
          style="width:120px;"
          @click="submit('next')"
        >保存并下一题</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import WhichComponent from '@/components/form/index';
import _ from 'lodash';
import { questionType, questionLevel } from '@/data/data';
import Allform from '@/components/form/form.js';
import { questionServer, courseServer, keyServer } from '@/api/api'
export default {
  components: { ...Allform },
  provide () {
    return {
      formData: this.formData,
      rules: this.rules
    }
  },
  computed: {
    getKey () {
      return this.baseformData.questionKey ? this.baseformData.questionKey.split(';') : []
    }
  },
  data() {
    return {
      props: {
        multiple: false,
        label: 'name',
        value: 'id',
        children: 'subList',
        checkStrictly: true,
        emitPath: false
      },
      rules: {},
      loading: false,
      directoryList: [],
      professionData: [],
      questionType,
      questionLevel,
      baseformData: {
        questionKey: '',
        directoryId: null,
        level: null,
        profession: [],
        professionName: ''
      },
      formData: {
        templateId: 1
      }
    };
  },
  methods: {
    changeSelect (a) {
      this.loading = true;
      this.INITformdata(a)
      let t = setTimeout(() => {
        this.loading = false;
        clearTimeout(t)
      }, 400)
    },
    INITparams (tpid) {
      const answer = this.getanswer(tpid)
      const options = this.getoptions(tpid)
      let params = {
        type: this.formData.templateId,
        ...this.baseformData,
        // 题干
        content: this.formData.textareaData.controlValue,
        contentImg: this.formData.UIdata.controlValue.map(v => v.key).join(),
        // 选项
        options: options ? JSON.stringify(options) : null,
        // 正确答案
        answer: answer,
        // 解析
        analysisContent: this.formData.jxtextareaData.controlValue,
        analysisImg: this.formData.jxUIdata.controlValue.map(v => v.key).join(),
        profession: this.baseformData.profession.join(','),
        professionName: this.baseformData.professionName
      }
      return params
    },
    async submit(isnext) {
      let flag = await this.submitForm('form');
      let flagV2 = !this.formData.textareaData.controlValue;
      let flagV3 = await this.submitFormV1();
      let flagV4 = await this.submitFormV2();
      if (!flag || flagV2 || flagV3 || flagV4) {
        this.$message.error('请检查必填!')
        return
      }
      let params = this.INITparams(this.formData.templateId)
      if (params.type === 2 && params.answer.length  <= 1) {
        this.$message.error('多选题答案不得少于两个选项!')
        return
      }
      const id = this.$route.query.id
      if (id) {
        questionServer.questionUpdate({
          id,
          ...params
        }).then(res => {
          const {code, message} = res
          if (code === '0') {
            if (isnext) {
              this.$message.success(message)
              this.changeSelect(this.formData.templateId)
            } else {
              this.close(false)
            }
          } else {
            this.$message.error(message)
          }
        }).catch((error) => {
          this.$message.error(error.response.data.message)
        })
        return
      }
      questionServer.questionAdd({
        ...params,
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          if (isnext) {
            this.$message.success(message)
            this.changeSelect(this.formData.templateId)
          } else {
            this.close(false)
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error.response.data.message)
      })
    },
    getDetail () {
      questionServer.questionDetail({
        id: this.$route.query.id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.baseformData = {
            questionKey: data.questionKey,
            directoryId: data.directoryId,
            level: data.level,
            profession: data.profession ? data.profession.split(',') : [],
            professionName: data.professionName
          }
          this.formData.templateId = data.type
          this.INITresdetail(data)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    INITresdetail (res) {
      this.baseformData.profession = res.profession ? res.profession.split(',') : []
      this.updateProfessionName()
      this.changeSelect(res.type)
      let f = this.formData
      f.textareaData.controlValue = res.content
      if (res.type !== 3 && res.type !== 5) {
        f.controls = JSON.parse(res.options)
        this.getfileurl(f.controls.map(v => v.key), f.controls)
      }
      if (res.type === 5) {
        f.controls = JSON.parse(res.answer)
      }
      f.answer.controlValue = res.answer
      if (res.type === 4) {
        f.answer.controlValue = res.answer.split(',')
      }
      f.jxtextareaData.controlValue = res.analysisContent
      f.UIdata.controlValue = res.contentImg ? res.contentImg.split(',').map(v => { return {key: v}}) : []
      this.getfileurl(f.UIdata.controlValue.map(v => v.key), f.UIdata.controlValue)
      f.jxUIdata.controlValue = res.analysisImg ? res.analysisImg.split(',').map(v => { return {key: v}}) : []
      this.getfileurl(f.jxUIdata.controlValue.map(v => v.key), f.jxUIdata.controlValue)
    },
    getfileurl (fileKeys, data) {
      this.$getUrl({
      fileKeys: fileKeys.join()
      }).then(obj => {
        if (obj) {
          data.forEach((e) => {
            if (e) {
              this.$set(e, 'fileUrl', obj[e.key] || '')
            }
          })
        }
      })
    },
    INITformdata (a) {
      let checked = a === 1 ? 'single' : a === 2 ? 'multiple' : a === 3 ? 'judge' : a === 4 ? 'sort' : 'gap'
      this.getcontrols(a, checked)
    },
    getcontrols (tpid, checked) {
      let json = _.cloneDeep(require(`../json/index`));
      Object.keys(json).forEach(k => {
        json[k] = Object.assign(_.cloneDeep(json[k]), { fieldId: `${json[k].controlType}_${new Date().getTime()}_${Math.random()}` });
      })
      // json.textareaData = this.formData.textareaData ? this.formData.textareaData : json.textareaData
      // json.UIdata = this.formData.UIdata ? this.formData.UIdata : json.UIdata
      this.$set(this.formData, 'textareaData', json.textareaData)
      this.$set(this.formData, 'UIdata', json.UIdata)
      this.$set(this.formData, 'jxtextareaData', json.jxtextareaData)
      this.$set(this.formData, 'jxUIdata', json.jxUIdata)
      this.$set(this.formData, 'answer', {...json.IUIdata, checked})
      const prop = this.getprop(tpid)
      this.$set(this.formData, 'controls', json[prop]);
    },
    getprop (tpid) {
      var prop = ''
      switch(tpid) {
        case 1: prop = 'IUIcontrols'
        break;
        case 2: prop = 'IUIcontrols'
        break;
        case 4: prop = 'IUIcontrols'
        break;
        case 3: prop = 'JUDGEcontrols'
        break;
        case 5: prop = 'GAPcontrols'
        break;
      }
      return prop
    },
    getanswer (tpid) {
      var answer = ''
      switch(tpid) {
        case 1: answer = this.formData.answer.controlValue
        break;
        case 2: answer = this.formData.answer.controlValue
        break;
        case 4: answer = this.formData.answer.controlValue.join()
        break;
        case 3: answer = this.formData.answer.controlValue
        break;
        case 5: answer = JSON.stringify(this.formData.controls)
        break;
      }
      return answer
    },
    getoptions (tpid) {
      var options = ''
      switch(tpid) {
        case 1: options = this.formData.controls
        break;
        case 2: options = this.formData.controls
        break;
        case 4: options = this.formData.controls
        break;
        case 3: options = null
        break;
        case 5: options = null
        break;
      }
      return options
    },
    submitForm (prop) {
      return new Promise((resolve) => {
        this.$refs[prop].validate((valid) => {
          if (valid) {
            resolve(true)
          } else {
            resolve(false)
          }
        });
      })
    },
    submitFormV1 () {
      let flag = true
      let tpid = this.formData.templateId
      if (tpid === 1 || tpid === 2  || tpid === 4 || tpid === 5 ) {
        flag = this.formData.controls.some(v => !v.content)
      } else {
        flag = false
      }
      return !!flag
    },
    submitFormV2 () {
      let flag = true
      let tpid = this.formData.templateId
      if (tpid !== 5) {
        flag = String(this.formData.answer.controlValue)
        if (tpid === 4) {
          flag = this.formData.answer.controlValue.length === this.formData.controls.length
        }
      }
      return !flag
    },
    changeKey (v) {
      this.$set(this.baseformData, 'questionKey', v.join(';'));
    },
    // 更新 professionName 方法
    updateProfessionName() {
      const selectedIds = this.baseformData.profession;
      const names = this.professionData
        .filter(item => selectedIds.includes(item.id))
        .map(item => item.dictionaryName);
      this.baseformData.professionName = names.join(',');
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 专业数据
    selectDataV1 () {
      keyServer.profession({
        dictionaryKey: 'profession'
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.professionData = data
          if (!this.$route.query.id) {
            this.baseformData.profession = this.professionData.map(v => v.id)
            this.updateProfessionName()
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
    },
    async close (flag) {
      if (flag) {
        this.$confirm('当前页未保存，是否确认继续', '提示', { type: 'warning' }).then(() => {
          window.close()
        })
      } else {
        window.close()
      }
    }
  },
  created () {
    this.selectData()
    this.selectDataV1()
    this.changeSelect(1)
    if (this.$route.query.id) {
      this.getDetail()
    }
  }
};
</script>
<style scoped lang='scss'>
.main{
  text-align: left;
  margin: 0px 10px;
  max-height: calc(100vh - 74px);
  overflow: auto;
  padding-right: 8px;
  margin-right: -2px;
}
.base-form {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
  text-align: left;
  margin: 10px 0;
  padding: 15px 20px 0;
  .title {
    font-weight: 700;
  }
}
.main-form {
  overflow: hidden;
  margin: 90px 0;
  margin-top: 15px;
  padding: 15px 20px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
}
.btns{
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  line-height: 80px;
  background: #f9fbff;
  width: 100%;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/addquestionIndex.vue